import '@plone/components/dist/basic.css';
import Card from '../Card/View';
import news1 from '@plone/volto/icons/show-blocks.svg';
import news2 from '@plone/volto/icons/slider.svg';
import news3 from '@plone/volto/icons/laptop.svg';
import news4 from '@plone/volto/icons/showcase.svg';
import { Icon } from '@plone/volto/components';

const cardData = [
  {
    icon: <Icon size="50px" name={news1} />,
    title: 'Objetivo',
    description:
      '<ul><li>Desarrollo de un sistema nacional de monitorización de  CO<sub>2</sub> y CH<sub>4</sub> capaz de producir estimaciones de emisiones recientes a alta resolución combinando datos de actividad con mediciones atmosféricas.</li></ul>',
  },
  {
    icon: <Icon size="50px" name={news2} />,
    title: 'Cómo',
    description:
      '<ul><li>Baja latencia y alta resolución: estimación de emisiones de CO<sub>2</sub> y CH<sub>4</sub> con alta resolución espacial (1kmx1km) y temporal (diaria) utilizando datos de actividad recientes vinculados a las fuentes de emisión, con un plazo máximo de 3 meses desde su ocurrencia. .</li><li>Mediciones continuas: ampliación de la actual red nacional de observación de GEI operada por AEMET a las principales áreas metropolitanas de España.</li><li>Distribución geográfica: mapas de emisiones anuales de CO<sub>2</sub> y CH<sub>4</sub> por actividad contaminante, coherentes con el inventario oficial reportado por el <a href="https://www.miteco.gob.es/es/calidad-y-evaluacion-ambiental/temas/sistema-espanol-de-inventario-sei-.html"> MITECO.</a></li></ul>',
  },
  {
    icon: <Icon size="50px" name={news3} />,
    title: 'Producto',
    description:
      '<ul><li>Web app para la visualización, análisis y descarga de datos de emisiones de GEI en España.</li></ul>',
  },
  {
    icon: <Icon size="50px" name={news4} />,
    title: 'Impactos',
    description:
      '<ul><li>Apoyo a entidades que representan grandes focos de emisión de GEI: información práctica de emisiones con la resolución espacial, temporal y sectorial necesaria para evaluar y orientar el avance hacia los objetivos de reducción de GEI fijados para los próximos años.</li><li>Toma de decisiones informada: herramientas y resultados accesibles para la administración pública, la comunidad científica, las entidades privadas y la ciudadanía. </li></ul>',
  },
];

const isImageCard = false;
const isBlock = true;

const CardGrid = () => {
  return (
    <div className="block-grid">
      {cardData.map((card, index) => (
        <div className="card-grid-item-block" key={index}>
          <Card
            icon={card.icon}
            title={card.title}
            description={card.description}
            isImageCard={isImageCard}
            isBlock={isBlock}
          />
        </div>
      ))}
    </div>
  );
};

export default CardGrid;
